import { render } from "./DocumentReportExportedDocuments.vue?vue&type=template&id=09e35bec&scoped=true&ts=true"
import script from "./DocumentReportExportedDocuments.vue?vue&type=script&lang=ts"
export * from "./DocumentReportExportedDocuments.vue?vue&type=script&lang=ts"

import "./DocumentReportExportedDocuments.vue?vue&type=style&index=0&id=09e35bec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e35bec"]])

export default __exports__